import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { applySeo, resolveLaunchSeo, getActivePostSeoId } from "../utils/seoMeta";

/**
 * Layer SEO di lancio: aggiorna title + og/twitter (senza react-helmet).
 * Post in vista vincono via PostShareMeta / getActivePostSeoId.
 */
export default function LaunchSeoMeta() {
  const { pathname, search } = useLocation();
  useEffect(() => {
    if (getActivePostSeoId()) return; // post meta wins while focused
    applySeo(resolveLaunchSeo(pathname, search));
  }, [pathname, search]);
  return null;
}
